export { withScrollLock } from "./ScrollLock";
